module.exports = __webpack_public_path__ + "static/media/ExpandArrowWhite.6c61f41c.svg";